import React from 'react';
import { Check, Trash2 } from 'lucide-react';
import { Input } from '../ui/input';
import { stationLabel } from '../../utils/kitchenTasks';

// Whole row is clickable (tablet-friendly, ≥44px). Inputs stop propagation.
const AdminPrepItemRow = ({
  item,
  prep,
  isChecked,
  editMode,
  onToggleCheck,
  onUpdateField,
  onDelete,
}) => {
  return (
    <div
      role="checkbox"
      aria-checked={isChecked}
      tabIndex={0}
      onClick={() => onToggleCheck(item.id)}
      onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); onToggleCheck(item.id); } }}
      className={`px-3 md:px-5 min-h-[52px] py-2 flex items-center gap-3 cursor-pointer select-none transition-colors border-l-4 ${isChecked ? 'bg-neon-pink/10 border-l-neon-pink' : 'border-l-transparent hover:bg-gray-50'}`}
      data-testid={`prep-item-row-${item.id}`}
      data-selected={isChecked ? 'true' : 'false'}
    >
      <span
        className={`w-7 h-7 rounded-lg border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isChecked ? 'bg-neon-pink border-neon-pink text-gray-900' : 'border-gray-300 bg-white'}`}
        data-testid={`checkbox-${item.id}`}
        aria-hidden="true"
      >
        {isChecked && <Check size={18} strokeWidth={3} />}
      </span>
      <div className="flex-1 min-w-0">
        <span className={`font-medium text-sm block truncate ${isChecked ? 'text-gray-900' : 'text-gray-800'}`}>{item.name}</span>
        <span className="text-[11px] text-gray-400">{stationLabel(item.station)}</span>
      </div>
      <Input
        type="text"
        value={prep.note || ''}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        onChange={(e) => onUpdateField(item.id, 'note', e.target.value)}
        placeholder="Note…"
        className="h-9 w-1/3 max-w-[180px] px-2 rounded-lg bg-gray-100 border-gray-200 text-gray-900 text-xs text-right flex-shrink-0"
        data-testid={`note-input-${item.id}`}
      />
      {editMode && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onDelete(item.id); }}
          className="w-9 h-9 rounded-lg text-red-600 hover:bg-red-500/10 flex items-center justify-center flex-shrink-0"
          data-testid={`delete-item-${item.id}`}
          aria-label="Supprimer"
        >
          <Trash2 size={14} />
        </button>
      )}
    </div>
  );
};

export default AdminPrepItemRow;
